
import React from "react";
import { Loader2 } from "lucide-react";

interface LoadingIndicatorProps {
  message?: string;
  className?: string;
}

export const LoadingIndicator = ({ 
  message = "Carregando dados...", 
  className = "" 
}: LoadingIndicatorProps) => {
  return (
    <div className={`flex justify-center items-center p-8 ${className}`}>
      <Loader2 className="h-8 w-8 animate-spin text-green-600" />
      <span className="ml-2 text-lg font-medium">{message}</span>
    </div>
  );
};
